import Header from "./Componant/Header/Header";
import React, {useEffect} from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./Componant/Home/Home";
import LogIn from "./Componant/LogIn/LogIn";
import LoginForm from "./Componant/LogIn/LogInForm";
import Dashboard from "./Componant/DaashBoard/Dashboard";
import {Navigate, useLocation} from "react-router";
import PageNotFound from "./Componant/PageNotFound/PageNotFound";
import Form8Page from "./Componant/DaashBoard/Form8/Form8Page";
import Form8 from "./Componant/DaashBoard/Form8/Form8";
import Form8EditPage from "./Componant/DaashBoard/Form8/Form8EditPage";
import Form8PrintPage from "./Componant/DaashBoard/Form8/Form8PrintPage";
import Form9Page from "./Componant/DaashBoard/Form9/Form9Page";
import Form9Edit from "./Componant/DaashBoard/Form9/Form9Edit";
import TaxReceiptPage from "./Componant/TaxReceipt/TaxReceiptPage";

function App() {

  return (
      <Router>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<LogIn />} />
          <Route path="/admin/home" element={<PrivateRoute><Dashboard /></PrivateRoute> } />

          <Route path="/admin/form8Page" element={<PrivateRoute><Form8Page/></PrivateRoute>} />
          <Route path="/admin/Form8AddInformation" element={<PrivateRoute><Form8/></PrivateRoute>} />
          <Route path="/admin/Form8EditInformation" element={<PrivateRoute><Form8EditPage/></PrivateRoute>} />
          <Route path="/admin/Form8PrintPage" element={<PrivateRoute><Form8PrintPage/></PrivateRoute>} />

          <Route path="/admin/form9Page" element={<PrivateRoute><Form9Page/></PrivateRoute>} />
          <Route path="/admin/form9Edit" element={<PrivateRoute><Form9Edit/></PrivateRoute>} />

          <Route path="/admin/form10Page" element={<PrivateRoute><Form9Page/></PrivateRoute>} />
          <Route path="/admin/TaxReceiptPage" element={<PrivateRoute><TaxReceiptPage/></PrivateRoute>} />


          <Route path={"*"} element={<PageNotFound/>}/>
        </Routes>
      </Router>
  );
}

export default App;

const PrivateRoute = ({ children }) => {
  const sessionData = sessionStorage.getItem('data');
  if (!sessionData) {
    return <Navigate to="/login" replace />;
  }
  return children;
};